import React from "react";
import "../../assets/css/home-page/map.css";

const Map = () => {
  return (
    <section className="map-section" id="location">
      <div className="container map-split-layout">
        {/* Left Side: Practical Visiting & Logistics Info */}
        <div className="map-info-panel">
          <div className="map-header">
            <span className="map-subtitle">Plant Operations</span>
            <h2>Visit Our Manufacturing Unit</h2>
            <p>
              We welcome dealers, infrastructure contractors, and structural
              engineers to inspect our production lines, reinforcement cages,
              and hydraulic testing rigs firsthand.
            </p>
          </div>

          <div className="plant-meta-grid">
            <div className="meta-card">
              <span className="meta-icon">⏱️</span>
              <div>
                <h4>Dispatch & Gate Hours</h4>
                <p>Monday – Saturday: 08:00 AM – 06:00 PM</p>
              </div>
            </div>

            <div className="meta-card">
              <span className="meta-icon">🚛</span>
              <div>
                <h4>Logistics & Transit Note</h4>
                <p>
                  Heavy flatbed access via National Highway arterial routes.
                  On-site overhead gantry crane available for secure pipe
                  loading.
                </p>
              </div>
            </div>

            <div className="meta-card">
              <span className="meta-icon">👷‍♂️</span>
              <div>
                <h4>Site Safety Mandate</h4>
                <p>
                  Hard hats and safety shoes are strictly required for entry
                  into the active centrifugal casting assembly yards.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Framed Map Viewport */}
        <div className="map-viewport-panel">
          <div className="map-container">
            <iframe
              title="Company Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21584.23487773826!2d74.83070752979178!3d12.889933464961308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba35a4c37bf488f%3A0x827bbc7a74fcfe64!2sMangaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1784632191516!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Map;
